module.exports = __webpack_public_path__ + "static/media/ico_simulation_face_marionette.abf34753.png";